import React, { Children } from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import { DragDropContext, Draggable, Droppable } from "react-beautiful-dnd";
import { FlexRow } from "../../FlexRow/FlexRow";
import { AddTabButton } from "./AddTabButton/AddTabButton";
import "./TabList.scss";

export class TabList extends React.Component {
  static propTypes = {
    children: PropTypes.node,
    onAdd: PropTypes.func,
    addTabToolTip: PropTypes.string,
    onReorder: PropTypes.func,
  };

  constructor(props) {
    super(props);

    this.state = {
      isDragging: false,
    };
  }

  renderTabs = () => {
    const { children } = this.props;

    return this.renderScrollableWindow(children);
  };

  reorder(list, startIndex, endIndex) {
    const result = Array.from(list);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);
    return result;
  }

  onDragEnd = (result) => {
    const { children, onReorder } = this.props;
    const childrenArray = Children.toArray(children).map((tab) => {
      return tab.props.id;
    });

    const dataReordered = this.reorder(
      childrenArray,
      result.source.index,
      result.destination.index
    );

    onReorder(dataReordered, result.destination.index);
    this.setState({ isDragging: false });
  };

  onDragStart = () => {
    this.setState({ isDragging: true });
  };

  renderTabsWithDnd = () => {
    const { children } = this.props;

    const draggableChildren = Children.toArray(children).map((tab, index) => {
      return (
        <Draggable
          key={tab.props.id.toString()}
          draggableId={tab.props.id.toString()}
          index={index}
        >
          {(dragProvided) => {
            let transform = dragProvided.draggableProps.style?.transform;
            const { draggableProps } = dragProvided;

            if (transform) {
              transform = transform.replace(/,\s[-+]*\d+px\)/, ", 0px)");
              draggableProps.style = {
                ...draggableProps.style,
                transform,
              };
            }

            return (
              <div
                ref={dragProvided.innerRef}
                {...draggableProps}
                {...dragProvided.dragHandleProps}
              >
                {tab}
              </div>
            );
          }}
        </Draggable>
      );
    });

    return (
      <DragDropContext
        onDragEnd={this.onDragEnd}
        onDragStart={this.onDragStart}
      >
        <Droppable droppableId="droppable" direction="horizontal">
          {(dropProvided) => (
            <div {...dropProvided.droppableProps} ref={dropProvided.innerRef}>
              {this.renderScrollableWindow(
                draggableChildren,
                dropProvided.placeholder
              )}
            </div>
          )}
        </Droppable>
      </DragDropContext>
    );
  };

  renderScrollableWindow = (children, placeholderComponent) => {
    return (
      <div className="TabList__scroll">
        <FlexRow className="TabList__tabs" gap="XS">
          {children}
          {placeholderComponent && placeholderComponent}
        </FlexRow>
      </div>
    );
  };

  render() {
    const { addTabToolTip, onAdd, onReorder } = this.props;

    const { isDragging } = this.state;

    const isDraggable = !!onReorder;

    const tabListClass = classNames("TabList", {
      isDragging,
    });

    return (
      <div className={tabListClass}>
        {isDraggable ? this.renderTabsWithDnd() : this.renderTabs()}
        {onAdd && (
          <AddTabButton onClick={onAdd} addTabToolTip={addTabToolTip} />
        )}
      </div>
    );
  }
}

export default TabList;
